import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import moment from 'moment';
import { processTutoringRequest, tutoringSharedTypes } from './Constants';
import { FRONTEND_URL } from '../../services/Constants';
import { EVENTS_TYPES } from '../../pagesNext/shared/Constants';
import { getLiveLessonPath } from '../pages/lesson/Constants';
import { adjustTimezone } from '../../services/Helper';
import { getSubjectName } from './Selectors';
import * as tutoringSharedActions from './Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as lessonDetailsActions from '../pages/lessonDetails/Actions';
import * as sharedActions from '../../pagesNext/shared/Actions';
import * as notificationActions from '../../components/notification/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			tutoringSharedTypes.SIGN_UP_LIVE_LESSON_REQUEST,
			handleSignUpLiveLessonRequest,
		),
		yield takeLatest(tutoringSharedTypes.SEND_LOGS_REQUEST, handleSendLogsRequest),
	]);
}

export function* handleSignUpLiveLessonRequest({ payload }) {
	try {
		const {
			data: { requestData },
			callback,
		} = payload;
		const subjectName = yield select(getSubjectName);

		const { data } = yield call(
			processTutoringRequest,
			'scheduled_lesson_users',
			'POST',
			requestData,
		);

		const { success, error } = data || {};

		if (!success && error?.title) {
			yield put(notificationActions.createNotification(error?.title, null, true, 3000));
			yield put(tutoringSharedActions.signUpLiveLessonError());
			return;
		}

		const { scheduled_lesson } = data || {};

		if (subjectName) {
			scheduled_lesson.subject = subjectName;
		}

		if (scheduled_lesson.event_data) {
			const { lesson_start_time } = scheduled_lesson.event_data;
			const lessonStartTime = adjustTimezone(moment.utc(lesson_start_time, 'HH:mm')).format(
				'HH:mm',
			);

			const lessonEventData = {
				...scheduled_lesson.event_data,
				lesson_start_time: lessonStartTime,
			};

			const eventData = {
				event_name: EVENTS_TYPES.LIVE_CLASS_SIGNED_UP,
				meta_data: {
					...lessonEventData,
					subject: scheduled_lesson.subject || '',
					weekday: moment(scheduled_lesson.event_data?.lesson_date, 'DD-MM-YYYY').format(
						'dddd',
					),
					chapter_id: requestData.scheduled_lesson_user?.chapter_id,
					lesson_call_page_url:
						FRONTEND_URL + getLiveLessonPath(scheduled_lesson.scheduled_lesson_id),
				},
			};
			yield put(sharedActions.sendEventRequest(eventData));
		}

		yield put(tutoringSharedActions.signUpLiveLessonSuccess());
		yield put(lessonDetailsActions.setSignedUp(true));
		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(tutoringSharedActions.signUpLiveLessonError());
	}
}

export function* handleSendLogsRequest({ payload }) {
	try {
		const { data: requestData, callback } = payload;

		const { data } = yield call(
			processTutoringRequest,
			'scheduled_lesson_logs',
			'POST',
			requestData,
		);

		if (callback) callback();

		yield put(tutoringSharedActions.sendLogsSuccess(data));
	} catch (e) {
		yield put(tutoringSharedActions.sendLogsError());
		yield put(errorHandlerActions.handleError(e, 'ignore'));
	}
}
